import React from "react";
import { Link } from "react-router-dom";
import Button from '../button/Button';
import Text from '../text/Text'
import './styles.css';

const Numbers = () => {
    return(
        <div className="container">
            <div className="content" id="content-center">
                <div id='numbers-content'>
                    <Text as="p" fontSize={22}>Veja como o <strong>ÌMÒLAB</strong> já impactou a vida de mais de </Text>   
                    <Text as="p" fontSize={22} className='numbers-content-text'><strong id='red-text'>+20</strong><br />Alunos bolsistas e voluntários no projeto</Text>
                    <Text as="p" fontSize={22} className='numbers-content-text'><strong id='dark-green-text'>+4</strong><br />Projetos de pesquisa em andamento</Text>                
                    <Text as="p" fontSize={22} className='numbers-content-text'><strong id='green-text'>+10</strong><br />Professores parceiros no projeto</Text>                
                    <Text as="p" fontSize={22} className='numbers-content-text'><strong id='yellow-text'>+22</strong><br />Computadores no laboratório</Text>
                </div>
                <Link to='/Dashboard'>
                    <Button variant='gradient'>
                        Veja Mais
                    </Button>                
                </Link>
            </div>   
        </div>
    )
}

export default Numbers;